export default {
  rewriteRoute: {
    path: '/income',
    name: 'income',
  },
}
